import { useState, useEffect } from 'react';
import { LoadProductsUseCase } from '../../application/useCases';
import { Product } from '../../domain/entities';

export const useProducts = (vehicleId: number | null, token: string | null) => {
    const [products, setProducts] = useState<Product[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!vehicleId || !token) {
            setProducts([]);
            return;
        }

        const loadProducts = async () => {
            try {
                setIsLoading(true);
                const useCase = new LoadProductsUseCase();
                const result = await useCase.execute(vehicleId, token);
                setProducts(result);
            } catch (error) {
                console.error('Error loading products:', error);
                setProducts([]);
            } finally {
                setIsLoading(false);
            }
        };

        loadProducts();
    }, [vehicleId, token]);

    return {
        products,
        isLoading,
    };
};

